<template>
<div class="evaluation-wrapper">
  <div class="evaluation-main">
    <div class="main-title">
      <h1>专业评估</h1>
      <h2>ASSESSMENT</h2>
    </div>
    <!-- <div class="sub-title">8年作品评估经验<br>用数据和专业评语告诉你目前的水平</div> -->
    <!-- 第一步 -->
    <div class="evaluation-section step-one" v-show="step == 1">
      <div class="step-title">个人信息</div>
      <div class="step-intro">
        <div class="intro-item">凯诺承诺，所有评估材料将会严格保密</div>
        <!-- <div class="intro-item">请如实填写并留下你常用的联系方式，<br>让教务老师找到你</div> -->
      </div>
      <div class="step-form">
        <div class="form-item">
          <div class="form-label required">真实姓名</div>
          <div class="form-content">
            <div class="text-box"><input type="text" class="form-text" v-model="name"></div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label required">微信号</div>
          <div class="form-content">
            <div class="text-box"><input type="text" class="form-text" v-model="showWechat"></div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">QQ</div>
          <div class="form-content">
            <div class="text-box"><input type="text" class="form-text" v-model="qq"></div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label required">测评目的</div>
          <div class="form-content">
            <div class="form-picker" @click="purposeShow = true">
              <span class="placeholder" v-if="!evaluation_purpose">选择测评目的</span>
              <span class="value" v-else>{{purposeText}}</span>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label required">手机号</div>
          <div class="form-content">
            <div class="text-box phone-number">
              <div class="phone-code-picker" @click="prefixShow = true"><span>+{{prefix}}</span></div>
              <input type="text" class="form-text" v-model="phone_number">
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label required">验证码</div>
          <div class="form-content">
            <div class="text-box">
              <input type="text" class="form-text" v-model="code_number">
              <div class="valid-code-button" @click="getCode">
                <span v-if="!validSended && !validColdDown">获取验证码</span>
                <span v-if="validSended && !validColdDown"><icon icon-class="reload"></icon>重新获取验证码</span>
                <van-count-down v-if="validColdDown" ref="countDown" :time="countDownTime" :auto-start="false" @finish="countDownFinish">
                  <template #default="timeData"><span class="count-down-text">已发送 {{timeData.seconds}}s</span></template>
                </van-count-down>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="form-item">
          <div class="form-label required">如何得知凯诺</div>
          <div class="form-content">
            <div class="form-picker" @click="originShow = true">
              <span class="placeholder" v-if="!know_cano">未选择</span>
              <span class="value" v-else>{{know_cano}}</span>
            </div>
          </div>
        </div> -->
        <div class="submit"><button class="submit-button" @click="submitNextStep">下一步</button></div>
      </div>
    </div>
    <!-- 第二步 -->
    <div class="evaluation-section step-two" v-show="step == 2">
      <div class="step-title">评估信息</div>
      <div class="step-intro">
        <div class="intro-item">补充更多信息，可以更有针对性的进行咨询</div>
      </div>
      <div class="step-form">
        <div class="form-item">
          <div class="form-label">就读院校</div>
          <div class="form-content">
            <div class="text-box"><input type="text" class="form-text" v-model="college"></div>
          </div>
        </div>
        <div class="form-item" v-if="evaluation_purpose != 3 && evaluation_purpose != 4">
          <div class="form-label">就读专业</div>
          <div class="form-content">
            <div class="text-box"><input type="text" class="form-text" v-model="professional"></div>
          </div>
        </div>
        <div class="form-item" v-if="evaluation_purpose == 3 || evaluation_purpose == 4">
          <div class="form-label">就读专业</div>
          <div class="form-content">
            <div class="form-picker" @click="applyMajorShow = true">
              <span class="placeholder" v-if="!apply_major">未选择</span>
              <span class="value" v-else>{{applyMajorText}}</span>
            </div>
          </div>
        </div>
        <div class="form-item" v-if="evaluation_purpose == 1 || evaluation_purpose == 5 || evaluation_purpose == 6">
          <div class="form-label">申请专业</div>
          <div class="form-content">
            <div class="form-picker" @click="applyMajorShow = true">
              <span class="placeholder" v-if="!apply_major">未选择</span>
              <span class="value" v-else>{{applyMajorText}}</span>
            </div>
          </div>
        </div>
        <div class="form-item" v-if="evaluation_purpose == 1 || evaluation_purpose == 5 || evaluation_purpose == 6">
          <div class="form-label">申请季</div>
          <div class="form-content">
            <div class="form-picker" @click="applyTimeShow = true">
              <span class="placeholder" v-if="!apply_time">选择入学时间</span>
              <span class="value" v-else>{{apply_time}}</span>
            </div>
          </div>
        </div>
        <div class="form-item" v-if="evaluation_purpose == 1 || evaluation_purpose == 2 || evaluation_purpose == 5 || evaluation_purpose == 6">
          <div class="form-label">申请国家/地区</div>
          <div class="form-content">
            <div class="form-picker" @click="showCountryPicker">
              <span class="placeholder" v-if="apply_country.length == 0">选择申请国家/地区</span>
              <span class="value" v-else>{{applyCountryText}}</span>
            </div>
          </div>
        </div>
        <div class="form-item" v-if="evaluation_purpose == 2">
          <div class="form-label">求职方向</div>
          <div class="form-content">
            <div class="form-picker" @click="directionShow = true">
              <span class="placeholder" v-if="!job_direction">选择求职方向</span>
              <span class="value" v-else>{{jobDirectionText}}</span>
            </div>
          </div>
        </div>
        <div class="form-item" v-if="evaluation_purpose == 3 || evaluation_purpose == 4">
          <div class="form-label required">补充说明</div>
          <div class="form-content">
            <div class="textarea-box">
              <textarea class="form-textarea" maxlength="200" v-model="description"></textarea>
              <span class="text-limit">{{description.length}}/200</span>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">上传作品<span>单张不超过5M，最多可选9张</span></div>
          <div class="upload-tips">
            <icon icon-class="studio-ex-mark"></icon>
            <p>由于微信限制，如需上传超过九张图或PDF格式，请前往凯诺官网 www.canopyu.com 上传</p>
          </div>
          <div class="form-content">
            <div class="upload-wrapper">
              <div class="upload-item" v-for="(item, index) in imgList">
                <span class="delPic" v-if="item.status == 5" @click="delPic(item, 'imgList', 'ossList')"><icon icon-class="cuowu"></icon></span>
                <div class="preview-box">
                  <img :src="item.previewImage" alt="">
                  <div class="image-status" v-if="item.status != 5">上传中</div>
                </div>
              </div>
              <div class="upload-item uploader" v-show="imgList.length < 9">
                <div class="uploader-box" id="uploader">
                  <icon icon-class="jiahao"></icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="submited-content">
          <div class="submited-title"><icon icon-class="fabu"></icon>提交后请及时联系「凯诺君」获取评图结果</div>
          <div class="contact-box">
            <div class="contact-item">官方咨询QQ 2917824355 <a href="http://wpa.qq.com/msgrd?v=3&uin=2917824355&site=qq&menu=yes" target="_blank" class="contact-qq-link"><icon icon-class="icon3"></icon>立即咨询</a></div>
            <div class="contact-item">扫一扫添加凯诺君微信（微信号：Canopy2013）</div>
          </div>
          <div class="qrcode"><img src="/Application/Home/Resource/static/images/contact-wechat-qrcode.jpg" alt=""></div>
        </div>
        <div class="submit-wrapper">
          <button class="final-submit-button back" @click="backToLastStep">上一步</button>
          <button class="final-submit-button submit-evaluation" :disabled="submitting" @click="submitEvaluation">提交</button>
        </div>
      </div>
    </div>
  </div>

  <!-- 手机号前缀 -->
  <van-popup v-model="prefixShow" position="bottom">
    <van-picker
      show-toolbar
      :columns="prefixData"
      value-key="value"
      @cancel="prefixShow = false"
      @confirm="confirmPrefix"
    />
  </van-popup>

  <!-- 测评目的 -->
  <van-popup v-model="purposeShow" position="bottom">
    <van-picker
      show-toolbar
      :columns="purposrData"
      value-key="label"
      @cancel="purposeShow = false"
      @confirm="confirmPurpose"
    />
  </van-popup>

  <!-- 来源 -->
  <van-popup v-model="originShow" position="bottom">
    <van-picker
      show-toolbar
      :columns="originData"
      @cancel="originShow = false"
      @confirm="confirmOrigin"
    />
  </van-popup>

  <!-- 申请专业 -->
  <van-popup v-model="applyMajorShow" position="bottom">
    <van-picker
      show-toolbar
      :columns="majorData"
      value-key="label"
      @cancel="applyMajorShow = false"
      @confirm="confirmMajor"
    />
  </van-popup>
  <!-- 申请季 -->
  <van-popup v-model="applyTimeShow" position="bottom">
    <van-picker
      show-toolbar
      :columns="yearData"
      value-key="label"
      @cancel="applyTimeShow = false"
      @confirm="confirmTime"
    />
  </van-popup>
  <!-- 申请国家 -->
  <van-popup v-model="applyCountryShow" position="bottom">
    <div class="nation-picker">
      <div class="picker-toolbar">
        <button class="toolbar-control cancel" @click="cancelCountry">取消</button>
        <button class="toolbar-control confirm" @click="confirmCountry">确认</button>
      </div>
      <div class="nation-list">
        <div class="nation-item" v-for="item in countryData" @click="toggleCountryItem(item)">
          <span>{{item.text}}</span>
          <icon icon-class="duigou" v-if="item.selected"></icon>
        </div>
      </div>
    </div>
  </van-popup>
  <!-- 求职方向 -->
  <van-popup v-model="directionShow" position="bottom">
    <van-picker
      show-toolbar
      :columns="majorData"
      value-key="label"
      @cancel="directionShow = false"
      @confirm="confirmDirection"
    />
  </van-popup>

  <cano-dialog v-if="dialogShow" :close-on-click-modal="false">
    <div class="result-wrapper">
      <div class="result-title">评估已提交</div>
      <div class="new-user" v-if="is_new == 1">
        <p>登录账号：{{account}}</p>
        <p>默认密码：123456</p>
      </div>
      <div class="result-tips">
        请耐心等待，添加凯诺官方咨询<br>QQ: 2917824355<br>微信: canopy2013<br>获取评估结果
      </div>
      <div class="dialog-button" @click="closeDialog">好的</div>
    </div>
  </cano-dialog>
</div>
</template>

<style lang="less" scoped>
.evaluation-wrapper{
  .evaluation-main{
    margin-top: 30px;
    padding: 0 24px;
    font-size: 14px;
    color: #333;
    .main-title{
      h1{
        position: relative;
        font-size: 16px;
        line-height: 24px;
        padding-top: 10px;
        letter-spacing: 3px;
        &::after{
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 80px;
          height: 2px;
          background: #333;
        }
      }
      h2{
        font-size: 16px;
        line-height: 24px;
        margin-top: 4px;
        letter-spacing: 2px;
      }
    }
    .sub-title{
      margin-top: 12px;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 1.75px;
    }
    .evaluation-section{
      margin-top: 32px;
      padding-bottom: 78px;
      .step-title{
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
      }
      .step-intro{
        font-size: 13px;
        line-height: 18px;
        color: @cano;
        font-style: italic;
        margin-top: 12px;
        .intro-item{
          position: relative;
          padding-left: 11px;
          margin-top: 6px;
          &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 6px;
            width: 5px;
            height: 5px;
            background: @cano;
            border-radius: 50%;
          }
        }
      }
      .step-form{
        margin-top: 32px;
        .form-item{
          margin-bottom: 24px;
          .form-label{
            position: relative;
            margin-bottom: 12px;
            font-size: 14px;
            line-height: 14px;
            display: inline-block;
            &.required::after{
              content: '*';
              position: absolute;
              left: 100%;
              top: 0;
              font-size: 14px;
              color: #F85C5C;
            }
            span{
              margin-left: 4px;
              font-size: 12px;
              color: #666;
            }
          }
          .form-content{
            position: relative;
            .text-box{
              width: 100%;
              height: 44px;
              background: #FAFAFA;
              display: flex;
              align-items: center;
              &.phone-number{
                padding-left: 16px;
              }
              .phone-code-picker{
                position: relative;
                font-size: 17px;
                line-height: 17px;
                color: #666;
                padding-right: 17px;
                &::after{
                  content: '';
                  position: absolute;
                  top: 50%;
                  right: 0;
                  transform: translateY(-20%);
                  width: 0;
                  height: 0;
                  border-width: 4px 3px;
                  border-style: solid dashed dashed dashed;
                  border-color: #666 transparent transparent transparent;
                }
              }
              .valid-code-button{
                padding-right: 16px;
                color: @cano;
                white-space: nowrap;
                span{
                  display: flex;
                  align-items: center;
                }
                svg{
                  font-size: 17px;
                }
              }
              .form-text{
                background: #FAFAFA;
                padding: 0 16px;
                color: #666;
                flex: 1;
              }
            }
            .form-picker{
              position: relative;
              width: 100%;
              height: 44px;
              padding: 0 16px;
              display: flex;
              align-items: center;
              background: #FAFAFA;
              font-size: 14px;
              color: #666;
              &::after{
                content: '';
                position: absolute;
                top: 50%;
                right: 16px;
                // transform: translateY(-50%);
                width: 0;
                height: 0;
                border-width: 4px 3px;
                border-style: solid dashed dashed dashed;
                border-color: #999 transparent transparent transparent;
              }
              .placeholder{
                color: #999;
              }
              .value{
                max-width: 70%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            .form-tips{
              margin-top: 8px;
              font-size: 12px;
              line-height: 12px;
              color: #999;
            }
            .textarea-box{
              width: 100%;
              .form-textarea{
                width: 100%;
                padding: 8px 16px;
                font-size: 14px;
                line-height: 20px;
                color: #666;
                height: 180px;
                background: #FAFAFA;
                resize: none;
              }
              .text-limit{
                text-align: right;
                display: flex;
                justify-content: flex-end;
                margin-top: 4px;
                font-size: 12px;
                line-height: 12px;
                color: #999;
              }
            }
            .upload-wrapper{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              flex-wrap: wrap;
              margin-top: 12px;
              margin-bottom: -16px;
              .upload-item{
                position: relative;
                width: 96px;
                height: 96px;
                margin: 0 16px 16px 0;
                &:nth-child(3n){
                  margin-right: 0
                }
                &.uploader{
                  .uploader-box{
                    width: 100%;
                    height: 100%;
                    border: 1px dashed @cano;
                    background: #FFF;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                    border-radius: 4px;
                    svg{
                      font-size: 40px;
                      color: @cano;
                    }
                    span{
                      font-size: 12px;
                      line-height: 12px;
                      margin-top: 8px;
                      color: #CCC;
                    }
                  }
                  .preview-box{
                    position: relative;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    // width: 156px;
                    width: 100%;
                    height: 96px;
                    border-radius: 4px;
                    overflow: hidden;
                    img{
                      width: 100%;
                    }
                    .upload-status{
                      position: absolute;
                      left: 0;
                      bottom: 0;
                      width: 100%;
                      height: 24px;
                      color: #FFF;
                      font-size: 12px;
                      line-height: 24px;
                      text-align: center;
                      background: rgba(0, 0, 0, .4);
                      transition: all .2s;
                      &.done{
                        background: @cano;
                      }
                    }
                  }
                }
                .preview-box{
                  position: relative;
                  width: 100%;
                  height: 100%;
                  overflow: hidden;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  overflow: hidden;
                  border-radius: 4px;
                  background: #000;
                  img{
                    width: 100%;
                  }
                  .image-status{
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 20px;
                    line-height: 20px;
                    background: rgba(0, 0, 0, .5);
                    color: #FFF;
                    text-align: center;
                    font-size: 12px;
                  }
                }
                .delPic{
                  position: absolute;
                  top: -8px;
                  right: -8px;
                  width: 20px;
                  height: 20px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border: 1px solid #DDD;
                  border-radius: 50%;
                  background: #FFF;
                  z-index: 20;
                  svg{
                    font-size: 12px;
                    color: #999;
                  }
                }
              }
            }
          }
          .upload-tips{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            margin-top: -6px;
            svg{
              font-size: 12px;
              flex-shrink: 0;
              margin: 1px 2px 0 0;
              color: @cano;
            }
            p{
              font-size: 12px;
              line-height: 16px;
              color: @cano;
            }
          }
        }
        .submit{
          margin-top: 40px;
        }
        .submit-button{
          width: 100%;
          height: 44px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: @cano;
          outline: none;
          color: #FFF;
          border: 0;
          border-radius: 44px;
          transition: all .2s;
          &:active{
            opacity: .8;
          }
        }
        .submited-content{
          margin-top: 32px;
          .submited-title{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 14px;
            line-height: 18px;
            color: #333;
            font-weight: bold;
            svg{
              font-size: 14px;
              margin-right: 4px;
              color: @cano;
            }
          }
          .contact-box{
            padding-top: 2px;
            .contact-item{
              position: relative;
              display: flex;
              align-items: center;
              font-size: 13px;
              line-height: 20px;
              margin-top: 8px;
              color: #666;
              padding-left: 7px;
              &::after{
                content: '';
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                width: 3px;
                height: 3px;
                border-radius: 50%;
                background: @cano;
              }
              .contact-qq-link{
                margin-left: 12px;
                padding: 0 8px;
                border: 1px solid @cano;
                border-radius: 20px;
                color: @cano;
                display: flex;
                align-items: center;
                font-size: 12px;
                svg{
                  font-size: 14px;
                }
              }
            }
          }
          .qrcode{
            margin-top: 16px;
            width: 96px;
            height: 96px;
            img{
              width: 100%;
            }
          }
        }
        .submit-wrapper{
          margin-top: 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .final-submit-button{
            width: 45%;
            height: 44px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            border: 1px solid @cano;
            border-radius: 44px;
            background: #FFF;
            color: @cano;
            transition: all .2s;
            &:active{
              opacity: .8;
            }
            &.submit-evaluation{
              background: @cano;
              color: #FFF;
            }
          }
        }
      }
    }
  }
  .result-wrapper{
    padding: 40px 0 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .result-title{
      font-size: 20px;
      line-height: 20px;
      color: #333;
      font-weight: bold;
    }
    .new-user{
      margin-top: 16px;
      width: 220px;
      text-align: center;
      background: rgba(77, 162, 199, 0.1);
      border-radius: 5px;
      padding-top: 12px;
      p{
        font-size: 15px;
        line-height: 15px;
        color: @cano;
        margin-bottom: 12px;
      }
    }
    .result-tips{
      text-align: center;
      margin-top: 16px;
      font-size: 13px;
      line-height: 20px;
      color: #666;
    }
    .dialog-button{
      margin-top: 32px;
      width: 220px;
      height: 37px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: @cano;
      color: #FFF;
      font-size: 15px;
      border-radius: 37px;
      outline: none;
      transition: all .2s;
      &:active{
        opacity: .8;
      }
    }
  }
}
</style>

<style lang="less">
.van-popup.offset{
  transition: all .3s;
  // top: 40px;
}
.nation-picker{
  height: 45vh;
  display: flex;
  flex-direction: column;
  .picker-toolbar{
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .toolbar-control{
      height: 100%;
      padding: 0 16px;
      font-size: 14px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      &.cancel{
        color: #969799;
      }
      &.confirm{
        color: #576b95;
      }
    }
  }
  .nation-list{
    flex: 1;
    overflow-y: auto;
    .nation-item{
      height: 44px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #EEE;
      font-size: 14px;
      color: #666;
      padding: 0 16px;
      transition: all .2s;
      &:active{
        background: #F1F1F1;
      }
      svg{
        font-size: 14px;
        color: @cano;
      }
    }
  }
}
.count-down-text{
  font-size: 14px;
  color: #999;
}
</style>

<script>
import Utils from '@/untils/utils'
import canoDialog from '@/components/Common/dialog'
export default {
  data() {
    return {
      prefix: '86',
      know_cano: '',
      name: '',
      qq: '',
      // 数据: 手机号
      phone_number: '',
      // 数据: 邮箱
      email: '',
      // 数据：联系用微信
      showWechat: '',
      // 数据：联系用邮箱
      showEmail: '',
      // 数据: 验证码
      code_number: '',
      // 数据: 测评目的 1 留学 2 求职 3 设计提升 4 保研
      evaluation_purpose: '',
      purposeText: '',
      // 数据: 就读专业
      professional: '',
      // 数据: 就读院校
      college: '',
      // 数据: 申请专业
      apply_major: '',
      // 数据: 申请季
      apply_time: '',
      // 数据: 作品专业
      works_major: '',
      // 数据: 申请国家
      apply_country: [],
      applyCountryText: '',
      // 数据: 作品id:
      works_id: '',
      // 数据: 求职方向
      job_direction : '',
      jobDirectionText: '',
      // 数据: 补充说明
      description: "",
      // 用户id
      is_new: '',
      // 验证码倒计时
      countDownTime: 60 * 1000,
      // 正在倒计时
      validColdDown: false,
      // 是否已经发送过验证码
      validSended: false,
      // 当前的步数
      step: 1,
      // 目的选项
      purposrData: [
        {
          value: '5',
          label: '本科留学',
        },
        {
          value: '6',
          label: '研究生留学',
        },
        // {
        //   value: '2',
        //   label: '求职',
        // }
      ],
      // 国家/地区数据
      countryData: [],
      // 来源数据
      originData: ['朋友推荐', '微信公众号', '知乎', '微博', '官网', '搜索'],
      // 专业数据
      majorData: [
        {
          value: 1,
          label: '建筑'
        },
        {
          value: 2,
          label: '景观'
        },
        {
          value: 3,
          label: '城市设计'
        },
        {
          value: 6,
          label: '城市规划'
        },
        {
          value: 4,
          label: '室内设计'
        },
        {
          value: 7,
          label: '交互设计/服务设计'
        },
        {
          value: 8,
          label: '平面/视觉传达'
        },
        {
          value: 9,
          label: '工业设计'
        },
        {
          value: 117,
          label: '房地产'
        },
      ],
      // 申请季数据
      yearData: [`${new Date().getFullYear() + 1}年入学`, `${new Date().getFullYear() + 2}年入学`, `${new Date().getFullYear() + 3}年入学`, `其他`],
      // 评图方式
      reg: 'mobile',
      // 账号
      account: '',
      // picker options
      prefixShow: false,
      purposeShow: false,
      originShow: false,
      applyMajorShow: false,
      applyTimeShow: false,
      applyCountryShow: false,
      directionShow: false,
      // upload
      uploader: null,
      imgList: [],
      ossList: [],
      // button loading
      submitting: false,
      // dialog
      dialogShow: false,
    }
  },
  created() {
    this.$store.commit('setActiveMenu', '');
    // 获取国家/地区信息
    this.$root.post('/Public/get_location_tags').then(data => {
      if(data.location.length > 0) {
        data.location.forEach(item => {
          item.selected = false;
        })
      }
      this.countryData = data.location || [];
    })

    // 测试
    // this.step = 2;
    // this.evaluation_purpose = '5';
    // this.purposeText = '本科留学';
  },
  mounted() {
    this.setMultipleUpload(this.uploader, 'uploader', 'imgList', 'ossList');
  },
  computed: {
    prefixData() {
      return this.$store.state.prefixData;
    },
  },
  components: {
    canoDialog
  },
  methods: {
    // 上传多张张函数
    setMultipleUpload(obj, id, file, finalList) {
      let _this = this;
      obj = new plupload.Uploader({
        runtimes: 'html5,flash,silverlight,html4',
        browse_button: id,
        flash_swf_url: '/Application/Home/Resource/vendor/plupload-new/js/Moxie.swf',
        silverlight_xap_url: '/Application/Home/Resource/vendor/plupload-new/js/Moxie.xap',
        url: 'http://oss.aliyuncs.com',
        // 不检测重复文件
        filters: {},
        // 多文件上传
        multi_selection: true,
        init: {
          // 选择文件之后
          FilesAdded(up, files) {
            // 获取当前已上传的图片数量
            let objLength = _this[file].length;
            let canUploadFiles = 0
            files.forEach(item => {
              // 如果本次选中的图片数量超出了9张的限制，则自动删除多出的图片
              if(item.type.indexOf("image/") == -1) {
                _this.$notify('请上传图片文件');
                up.removeFile(item)
                return false;
              }else {
                objLength++;
                canUploadFiles++;
                if(objLength > 9) {
                  up.removeFile(item);
                };
                let fileName = item.name;
                _this.$root.previewUploadImage(item, (imgSrc) => {
                  item.previewImage = imgSrc;
                  _this[file].push(item);
                })
              }
            })
            if(canUploadFiles == files.length) {
              _this.$root.setUploadParam(up, '', false, 'upload/');
            }
          },
          // 上传前设置文件名
          BeforeUpload(up, fileObj) {
            _this.$root.setUploadParam(up, fileObj.name, true, 'upload/');
          },
          // 上传完成
          FileUploaded(up, fileObj, info) {
            if(info.status == 200) {
              let res = JSON.parse(info.response);
              let index= fileObj.name.lastIndexOf('.');
              let fileLength = fileObj.name.length;
              let suffix = fileObj.name.substring(index + 1, fileLength);
              res.info.ext = suffix;
              res.info.name = fileObj.name;
              _this.$root.post('/Oss/add_upload_log', res.info).then(data => {
                console.log(data);
                if(data.status == 1) {
                  _this[finalList].push(data.id)
                  console.log(_this[finalList], _this[file])
                }else {
                  _this.$notify('上传出错，请稍后再试');
                }
              })

              console.log(res)
            }
          },
          Error(up, err) {
            console.log(err);
          }
        }
      })
      // 初始化上传
      obj.init();
    },
    // 删除已上传的图片
    delPic(item, obj, ossObj) {
      let index = this[obj].indexOf(item)
      this[obj].splice(index, 1);
      this[ossObj].splice(index, 1);
      console.log(this[obj], this[ossObj])
    },
    confirmPurpose(e) {
      this.evaluation_purpose = e.value;
      this.purposeText = e.label;
      this.purposeShow = false;
    },
    confirmOrigin(e) {
      this.know_cano = e;
      this.originShow = false;
    },
    confirmPrefix(e) {
      this.prefix = e.value;
      this.prefixShow = false;
    },
    confirmMajor(e) {
      this.apply_major = e.value;
      this.applyMajorText = e.label;
      this.applyMajorShow = false;
    },
    confirmTime(e) {
      this.apply_time = e;
      this.applyTimeShow = false;
    },
    toggleCountryItem(item) {
      item.selected = !item.selected;
    },
    showCountryPicker() {
      if(this.apply_country.length > 0) {
        this.apply_country.forEach(country => {
          this.countryData.forEach(item => {
            if(country == item.num) {
              item.selected = true;
            }
          })
        })
      }
      this.applyCountryShow = true;
    },
    cancelCountry() {
      this.countryData.forEach(item => {
        item.selected = false;
      })
      this.applyCountryShow = false;
    },
    confirmCountry() {
      let countryArr = [];
      let countryTextArr = [];
      this.countryData.forEach(item => {
        if(item.selected) {
          countryArr.push(item.num)
          countryTextArr.push(item.text)
        }
      })
      this.apply_country = countryArr;
      this.applyCountryText = countryTextArr.join(',');
      this.applyCountryShow = false;
    },
    confirmDirection(e) {
      this.job_direction = e.value;
      this.jobDirectionText = e.label;
      this.directionShow = false;
    },
    // 获取验证码
    getCode() {
      if(this.validColdDown) return;
      if(this.phone_number == ''){
        this.$notify({message: '请输入手机号',className: 'offset'});return;
      }
      if(this.prefix == '86' && !Utils._match.mobile.test(this.phone_number)){
        this.$notify({message: '请输入正确的手机号',className: 'offset'});return
      }
      this.$root.post('/Public/sendMobileVerifyCode', {
        username: this.phone_number,
        prefix: this.prefix,
        checkexist: 1,
        nochecked: 1,
      }).then(data => {
        if(data.status == 1) {
          this.validColdDown = true;
          this.$nextTick(() => {
            this.$refs.countDown.start();
          })
          this.validSended = true;
        }else {
          this.$notify(data.msg);
        }
      })

    },
    countDownFinish() {
      this.validColdDown = false;
    },
    // 第一步提交
    submitNextStep() {
      // 第一步表单验证
      if(this.name == ''){this.$notify({message: '请填写姓名',className: 'offset'}); return}
      if(this.showWechat == ''){this.$notify({message: '请填写微信号',className: 'offset'}); return}
      // if(this.qq != '' && !Utils.validate_number(this.qq)){this.$notify({message: '请填写正确的QQ',className: 'offset'}); return}
      if(this.showEmail != '' && !Utils._match.email.test(this.showEmail)){this.$notify({message: '请填写正确的邮箱',className: 'offset'}); return}
      if(this.evaluation_purpose == ''){this.$notify({message: '请选择测评目的',className: 'offset'}); return}
      if(this.prefix == '86' && !Utils._match.mobile.test(this.phone_number)){this.$notify({message: '请输入正确的手机号',className: 'offset'}); return}
      if(this.code_number == ''){this.$notify({message: '请填写验证码',className: 'offset'}); return}
      // if(this.know_cano == ''){this.$notify({message: '请选择如何得知凯诺',className: 'offset'}); return}
      let stepOneBaseInfo = {

      }
      this.$root.post('/Evaluation/check_is_exist_evaluation', {
        name: this.name,
        qq: this.qq,
        prefix: this.prefix,
        mobile: this.phone_number,
        email: this.email,
        verify: this.code_number,
        purpose: this.purposeText,
        from: this.know_cano,
        reg: 'mobile'
      }).then(data => {
        console.log(data);
        if(data.status == 1) {
          this.step = 2;
          window.scrollTo(0, 0);
        }else {
          this.$notify({message: data.msg, className: 'offset'});
        }
      })
    },
    // 返回上一步
    backToLastStep() {
      this.step = 1;
      window.scrollTo(0, 0);
    },
    // 提交评图
    submitEvaluation() {
      // if(!this.college){this.$notify('请填写就读院校'); return}
      // if(this.ossList.length <= 0){this.$notify('请上传您的作品'); return}
      let params = {};
      switch(parseInt(this.evaluation_purpose)) {
        // 留学
        case 1: {
          // if(!this.professional) {
          //   this.$notify('请填写就读专业'); return
          // }
          // if(!this.apply_major) {
          //   this.$notify('请选择申请专业'); return
          // }
          // if(!this.apply_time) {
          //   this.$notify('请选择申请季'); return
          // }
          // if(this.apply_country.length <= 0) {
          //   this.$notify('请选择申请国家/地区'); return
          // }
          params = {
            // 基本信息
            name: this.name,
            qq: this.qq,
            prefix: this.prefix,
            mobile: this.phone_number,
            email: this.email,
            purpose: this.purposeText,
            from: this.know_cano,
            show_email: this.showEmail,
            show_wechat: this.showWechat,
            reg: 'mobile',
            // 目的信息
            attend_school: this.college,
            attend_major: this.professional,
            apply_major: this.apply_major,
            applytime: this.apply_time,
            apply_country: this.apply_country.join(','),
            works_ids: this.ossList.join(','),
          }
        };break;
        // 求职
        case 2: {
          // if(!this.professional) {
          //   this.$notify('请填写就读专业'); return
          // }
          // if(this.apply_country.length <= 0) {
          //   this.$notify('请选择申请国家/地区'); return
          // }
          params = {
            // 基本信息
            name: this.name,
            qq: this.qq,
            prefix: this.prefix,
            mobile: this.phone_number,
            email: this.email,
            purpose: this.purposeText,
            from: this.know_cano,
            show_email: this.showEmail,
            show_wechat: this.showWechat,
            reg: 'mobile',
            // 目的信息
            attend_school: this.college,
            attend_major: this.professional,
            job_direction: this.job_direction,
            apply_country: this.apply_country.join(','),
            works_ids: this.ossList.join(','),
          }
        };break;
        // 设计提升
        case 3: {
          // if(!this.apply_major) {
          //   this.$notify('请选择专业');break;
          // }
          // if(!this.description) {
          //   this.$notify('请填写补充说明');break;
          // }
          params = {
            // 基本信息
            name: this.name,
            qq: this.qq,
            prefix: this.prefix,
            mobile: this.phone_number,
            email: this.email,
            purpose: this.purposeText,
            from: this.know_cano,
            show_email: this.showEmail,
            show_wechat: this.showWechat,
            reg: 'mobile',
            // 目的信息
            attend_school: this.college,
            apply_major: this.apply_major,
            description: this.description,
            works_ids: this.ossList.join(','),
          }
        };break;
        // 考研保研
        case 4: {
          // if(!this.apply_major) {
          //   this.$notify('请选择专业');break;
          // }
          // if(!this.description) {
          //   this.$notify('请填写补充说明');break;
          // }
          params = {
            // 基本信息
            name: this.name,
            qq: this.qq,
            prefix: this.prefix,
            mobile: this.phone_number,
            email: this.email,
            purpose: this.purposeText,
            from: this.know_cano,
            show_email: this.showEmail,
            show_wechat: this.showWechat,
            reg: 'mobile',
            // 目的信息
            attend_school: this.college,
            apply_major: this.apply_major,
            description: this.description,
            works_ids: this.ossList.join(','),
          }
        };break;
        case 5: {
          params = {
            // 基本信息
            name: this.name,
            qq: this.qq,
            prefix: this.prefix,
            mobile: this.phone_number,
            email: this.email,
            purpose: this.purposeText,
            from: this.know_cano,
            show_email: this.showEmail,
            show_wechat: this.showWechat,
            reg: 'mobile',
            // 目的信息
            attend_school: this.college,
            attend_major: this.professional,
            apply_major: this.apply_major,
            applytime: this.apply_time,
            apply_country: this.apply_country.join(','),
            works_ids: this.ossList.join(','),
          }
        };break;
        case 6: {
          params = {
            // 基本信息
            name: this.name,
            qq: this.qq,
            prefix: this.prefix,
            mobile: this.phone_number,
            email: this.email,
            purpose: this.purposeText,
            from: this.know_cano,
            show_email: this.showEmail,
            show_wechat: this.showWechat,
            reg: 'mobile',
            // 目的信息
            attend_school: this.college,
            attend_major: this.professional,
            apply_major: this.apply_major,
            applytime: this.apply_time,
            apply_country: this.apply_country.join(','),
            works_ids: this.ossList.join(','),
          }
        };break;
      }
      console.log(params)
      params.evaluation_origin = 'mobile';
      this.submitting = true;
      this.$root.post('/Evaluation/add_student_evaluation', params).then(data => {
        this.submitting = false;
        if(data.status == 1) {
          this.account = this.phone_number;
          // 是否是新学生
          this.is_new = data.is_new;
          this.dialogShow = true;
        }else {
          this.$notify(data.msg)
        }
      })
    },
    // 关闭弹窗
    closeDialog() {
      window.location.href = window.location.origin;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Evaluation/index.vue